// @ts-nocheck
import * as React from "react";

const SaveFill: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                d="M8 3v7l.007.117A1 1 0 0 0 9 11h6a1 1 0 1 0 0-2h-5V3h3.17a3 3 0 0 1 2.12.88l4.83 4.83a3 3 0 0 1 .88 2.12V18a3 3 0 0 1-3 3h-2v-4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v4H6a3 3 0 0 1-3-3V6l.005-.176A3 3 0 0 1 6 3h2Zm6 14v4h-4v-4h4Z"
                fill="currentColor"
                fillRule="evenodd"
            />
        </svg>
    );
};

export default React.memo(SaveFill);
